<template>
  <el-row class="cs-contentContainer" style="background:#1756a6;padding-top:150px;">
    <el-col :span="24" class="cs-fullHeight cs-contentContainer-loginMiddle">
      <div class="cs-fullHeight-content">
        <el-form :model="loginForm" :rules="rules" ref="loginForm" class="cs-fullHeight-content">
          <el-row>
            <el-col :span="11">&nbsp;</el-col>
            <el-col :span="2">
              <img src="../../assets/video-logo.png" alt="管理员登陆" style="width:100%">
            </el-col>
          </el-row>
          <el-row class="cs-login-content">
            <el-col :span="24">
              <div class="grid-content">
                <el-row class="el-form-control">
                  <el-col :span="11">&nbsp;</el-col>
                  <el-col :span="4" class="backgroud-white login">
                    <el-form-item prop="name">
                      <el-input
                        class="login-input"
                        @change="checkAllInputs"
                        placeholder="管理员帐号"
                        v-model="loginForm.name"
                      ></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                      <el-input
                        class="login-input"
                        @keyup.enter.native="login"
                        @change="checkAllInputs"
                        placeholder="管理员密码"
                        type="password"
                        v-model="loginForm.password"                       
                      ><i @click="login" slot="suffix" style="cursor:pointer" class="el-input__icon fa fa-arrow-right"></i>
                      </el-input>

                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="el-form-control">
                  <el-col :span="12">&nbsp;</el-col>
                  <el-col :span="8">
                    <el-button v-show="false" v-bind:type="btnClass" @click="login">登 录</el-button>
                  </el-col>
                </el-row>
                <el-row class="el-form-control errorMessageContainer">
                  <el-col :span="11">&nbsp;</el-col>
                  <el-col :span="4" v-if="showError">
                    <el-alert :closable="false" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>


<style lang="scss" scoped>
.errorMessageContainer {
  min-height: 56px;
}

.el-form-control {
  margin-bottom: 0px;
}
.cs-login-bottom {
  height: 60px;
  footer {
    line-height: 60px;
  }
}
.footer {
  position: absolute;
  text-align: center;
  bottom: 2px;
}
.grid-content {
  border-radius: 0;
  border-right: 1px solid #1756a6;
  padding-right: 90px;
}
.cs-login-content {
  padding-top: 100px;
}
.cs-login-admin {
  padding-top: 100px;
}
.login {
  border-radius: 5px;
}
.el-form-item__error {
  top: 35px !important;
  left: 16px;
}

.el-input__inner {
  border-color: null;
}
.login .el-form-item {
  margin-bottom: 0;
}

.login-input {
  height: 50px !important;
  line-height: 50px !important;
}

.login .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
}
.el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
}
</style>

<script>
import { userLogin, validateToken } from "../../service/user.service";
import {
  getStore,
  setStore,
  saveAdminInStore,
  isInRole,
  isFrontDesk
} from "../../config/mUtils";
import global_ from "@/core/global";
export default {
  data() {
    return {
      global: global_,
      showError: false,
      errorMessage: "",
      btnClass: "info",
      loginForm: {
        name: "", //用户名
        password: "",
        loginType: global_.loginType.speedup.name
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.validateUserLogin();
  },
  methods: {
    validateUserLogin() {
      let token = getStore("admin_auth_token");
      let role = getStore("admin_user_role");
      if (token && role) {
        validateToken().then(result => {
          if (result && result.success) {
            this.$emit("logged-event", true);
            this.$router.push("/login");
          }
        });
      }
    },
    //发送登录信息
    async login() {
      if (!!this.$refs["loginForm"]) {
        let isValid = true;
        this.$refs["loginForm"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        let result = await userLogin(
          this.loginForm.name,
          this.loginForm.password,
          this.loginForm.loginType
        );
        if (result) {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            saveAdminInStore(result.data);
            this.$emit("logged-event", true);
            this.$router.push("/login");
          }
        }
      }
    },
    checkAllInputs() {
      if (!!this.loginForm.name && !!this.loginForm.password) {
        this.btnClass = "primary";
      } else {
        this.btnClass = "info";
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/page/admin/login.vue